export class SubjectRecurrent {
	tipoIdentificacion: string;
	identificacion: string;
	idEps: string;
	idDireccion: string;
	idCiudad: string;
}

